import { useEffect, useState } from "react";    
import { Spinner } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
const parse = require('html-react-parser');

function Reasons({ sportcode,
    proj_id,
    gameid,
    label,
    teamid,
    homeid,
    homename,
    awayid,
    awayname
}) {
    
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(true);

    let tmreasons = {};
    tmreasons[homeid] = [];
    tmreasons[awayid] = [];
    

    const [teamReasons, setTeamReasons] = useState(tmreasons);   
    const [activeTeamId, setActiveTeamId] = useState(teamid);
    const [teamCounts, setTeamCounts] = useState({
        OFF: 0,
        DEF: 0,
        OTH: 0,
        ALL: 0,
    });

    const defaultPageSize = 3;
    const [activePosition, setActivePosition] = useState('ALL');
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(defaultPageSize);
    const [activeReasons, setActiveReasons] = useState([]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const updateTeamCounts = (gameReasons, tmId) => {

        let tmReasons = gameReasons[tmId];

        let offcount = tmReasons ? tmReasons.filter(function (r) { return r.reason.SubjectClass == 'OFF' }).length : 0;
        let defcount = tmReasons ? tmReasons.filter(function (r) { return r.reason.SubjectClass == 'DEF' }).length : 0;
        let othcout = tmReasons ? tmReasons.filter(function (r) { return r.reason.SubjectClass == 'OTH' }).length : 0;
        let allcount = offcount + defcount + othcout;
        setTeamCounts({
            OFF: offcount,
            DEF: defcount,
            OTH: othcout,
            ALL: allcount,
        });
    };

    const handleTeam = (tmId) => {

        setActiveTeamId(tmId);

        let newIndex = 1;
        setPageIndex(newIndex);

        let newPageSize = defaultPageSize;
        setPageSize(newPageSize);

        updateTeamCounts(teamReasons, tmId);

        initActiveReasons(newIndex, newPageSize, filterTeamReasons(teamReasons, tmId, activePosition));
    };

    const handlePosition = (pos) => {

        setActivePosition(pos);

        let newIndex = 1;
        setPageIndex(newIndex);

        let newPageSize = defaultPageSize;
        setPageSize(newPageSize);

        initActiveReasons(newIndex, newPageSize, filterTeamReasons(teamReasons, activeTeamId, pos));
    };

    const handlePrevious = () => {

        let newIndex = pageIndex - 1;
        if (pageIndex > 1) {
            setPageIndex(newIndex);

            initActiveReasons(newIndex, pageSize, filterTeamReasons2());
        }
    }

    const handleNext = () => {

        let newIndex = pageIndex + 1;

        setPageIndex(newIndex);
        initActiveReasons(newIndex, pageSize, filterTeamReasons2());

    }

    const handleShowAll = () => {

        let newIndex = 1;
        setPageIndex(newIndex);

        let tmreasons = filterTeamReasons2?.()?.length > 0 ? filterTeamReasons2() : [];

        let newPageSize = defaultPageSize;
        if (defaultPageSize == pageSize) {
            newPageSize = tmreasons.length;
        }
        setPageSize(newPageSize);
        
        initActiveReasons(newIndex, newPageSize, tmreasons);
    }

    const initActiveReasons = function (index, psize, tmReasons) { 
        
        let newActiveReasons = [];
        let minI = (index - 1) * psize;
        let maxI = minI + (psize - 1);
        if (tmReasons) {
            
            for (let i = 0; i < tmReasons?.length; i++) {

                if (i >= minI && i <= maxI) {

                    newActiveReasons.push({
                        reason: tmReasons[i].reason,
                        s_reason: tmReasons[i].s_reason,
                        num: i + 1
                    });
                }
            }
        }
        
        setActiveReasons(newActiveReasons);
    }

    const getPositionClass = function (aPos, cnt) {

        let cl = 'btn btn-sm btn-outline-secondary positionreasons text-decoration-none mx-2 link-dark';
        if (aPos == activePosition) {
            cl += ' position-reasons-active';
        }
        if (cnt == 0) {
            cl += ' disabled';
        }

        return cl;
    };

    const  htmlToElement = function(html) {
        var template = document.createElement('template');
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        return template.content.firstChild;
    }

    const findRank = function (val) {
        //lowest,highest,worst,best

        let rank1 = "";
        var rank2 = "";
        if (val.indexOf("1st") >= 0 ||
            val.indexOf("first") >= 0) {
            rank1 = "1st";
        }
        else if (val.indexOf("2nd") >= 0 ||
            val.indexOf("second") >= 0) {
            rank1 = "2nd";
        }
        else if (val.indexOf("3rd") >= 0 ||
            val.indexOf("third") >= 0) {
            rank1 = "3rd";
        }
        else if (val.indexOf("4th") >= 0 ||
            val.indexOf("fourth") >= 0) {
            rank1 = "4th";
        }
        else if (val.indexOf("5th") >= 0 ||
            val.indexOf("fifth") >= 0) {
            rank1 = "5th";
        }
        else if (val.indexOf("6th") >= 0 ||
            val.indexOf("sixth") >= 0) {
            rank1 = "6th";
        }
        else if (val.indexOf("7th") >= 0 ||
            val.indexOf("seventh") >= 0) {
            rank1 = "7th";
        }
        else if (val.indexOf("8th") >= 0 ||
            val.indexOf("eighth") >= 0) {
            rank1 = "8th";
        }
        else if (val.indexOf("9th") >= 0 ||
            val.indexOf("ninth") >= 0) {
            rank1 = "9th";
        }
        else if (val.indexOf("10th") >= 0 ||
            val.indexOf("tenth") >= 0) {
            rank1 = "10th";
        }
        else {

            rank1 = "";

        }

        /// //lowest,highest,worst,best
        if (val.indexOf("lowest") >= 0) {
            rank2 = "lowest";
        }
        else if (val.indexOf("highest") >= 0) {
            rank2 = "highest";
        }
        else if (val.indexOf("worst") >= 0) {
            rank2 = "worst";
        }
        else if (val.indexOf("best") >= 0) {
            rank2 = "best";
        }
        else if (val.indexOf("most") >= 0) {
            rank2 = "most";
        }
        else if (val.indexOf("fewest") >= 0) {
            rank2 = "fewest";
        }
        else {
            rank2 = "";
        }

        return `${rank1 + ' ' + rank2}`;

    }

    const split_reason = function (reason) {

        let reasonA = null;
        let reasonB = null;
        if (reason.HTMLNote) {

            let match;
            let match_index;

            let match1 = "</span>.";
            let match_index1 = reason.HTMLNote.indexOf(match1);

            let match2 = "</span> .";
            let match_index2 = reason.HTMLNote.indexOf(match2);

            if (match_index1 >= 0 && match_index2 >= 0) {
                if (match_index1 < match_index2) {
                    match_index = match_index1;
                    match = match1;
                }
                else {
                    match_index = match_index2;
                    match = match2;
                }
            }
            else if (match_index1 >= 0) {
                match_index = match_index1;
                match = match1;
            }
            else if (match_index2 >= 0) {
                match_index = match_index2;
                match = match2;
            }
            else {
                let match3 = ").";
                let match_index3 = reason.HTMLNote.indexOf(match3);
                /*let match4 = "__";*/
                /*let match_index4 = reason.HTMLNote.indexOf(match4);*/
                if (match_index3 >= 0) {
                    match_index = match_index3;
                    match = match3;
                }
                //else if (match_index4 >= 0) {
                //    match_index = match_index4;
                //    match = match4;
                //}
            }

            if (match) {

                let replace_rank = function (rn) {

                    let rnElement = htmlToElement(`<div>${rn}</div>`);

                    let rinfoElement = rnElement.getElementsByClassName('rankinfo')[0];

                    let rinfoElement_span = rinfoElement.querySelector('span');
                    


                    let bestworst = ((rinfoElement_span && rinfoElement_span.classList.contains('positive')) || (rinfoElement && rinfoElement.classList.contains('positive')))
                        ? '<img style="height: 18px; margin-left: 10px;" src="/_ie/thumbs-up.png">'
                        : '<img style="height: 18px; margin-left: 10px;" src="/_ie/thumbs-down.png">';

                    if (rinfoElement_span && rinfoElement_span.length > 0) {
                        rinfoElement_span.innerHTML = bestworst + ' ' + findRank(rinfoElement.innerHTML);
                    }
                    else {
                        rinfoElement.innerHTML = bestworst + ' ' + findRank(rinfoElement.innerHTML);
                    }

                    return rnElement.innerHTML;
                }

                reasonA = replace_rank(reason.HTMLNote.substr(0, match_index + match.length + 1));
                reasonB = replace_rank(reason.HTMLNote.substr(match_index + match.length + 1, reason.HTMLNote.length));

                let removePeriod = function (reasonNote) {
                    if (reasonNote.trim()[reasonNote.trim().length - 1] == ".") {
                        reasonNote = reasonNote.trim().slice(0, -1);
                    }

                    return reasonNote;
                }
                if (reasonA) {
                    reasonA = removePeriod(reasonA);
                }
                if (reasonB) {
                    reasonB = removePeriod(reasonB);
                }

            }
        }

        return {
            reasonA: reason.AB == 'A' ? reasonA : reasonB,
            reasonB: reason.AB == 'A' ? reasonB : reasonA
        }

    };


    const filterTeamReasons = function (teamReasons, tmid, pos) {
        
        let reasons = teamReasons[tmid];
        
        if (pos == 'ALL') {

        }
        else if (reasons && reasons.length > 0) {
          reasons =  reasons.filter(r => {
                return r.reason.SubjectClass == pos
            });
        }

        return reasons;
    };

    const filterTeamReasons2 = function () {

        const ret = filterTeamReasons(teamReasons, activeTeamId, activePosition);

        if (ret) {
            return ret
        }
        else { return []}

    }

    useEffect(() => {
        async function fetchData() {

            const resp = await fetch(`/${sportcode}/Reasons`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body:`Proj_Id=${proj_id}&GameId=${gameid}`
            });

            const result = await resp.json();

            //update reasons data
            if (result) {
                
                let newTeamReasons = {};
                newTeamReasons[homeid] = [];
                newTeamReasons[awayid] = [];
                for (let i = 0; i < result.length; i++) {

                    let reason = result[i];
                    reason.HTMLNote = reason.HTMLNote.replaceAll('javascript:void(0);', '/');
                    reason.HTMLNote = reason.HTMLNote.replaceAll(`onclick='TeamNotes(${homeid});'`, '');
                    reason.HTMLNote = reason.HTMLNote.replaceAll(`onclick='TeamNotes(${awayid});'`, '');
                    let s_reason = split_reason(reason);

                    newTeamReasons[result[i].SubjectId].push({
                        reason: reason,
                        s_reason: s_reason
                    });
                }
                setTeamReasons(newTeamReasons);

                updateTeamCounts(newTeamReasons, activeTeamId);

                initActiveReasons(pageIndex, pageSize, newTeamReasons[activeTeamId]);
                
            }

            setLoading(false);

        }

        fetchData();
    }, [sportcode]);
        

    return (
        <>
            <Button variant="primary" onClick={handleShow} className="m-1">
                { label }
            </Button>

            <Modal
                size="lg"
                show={show}
                onHide={handleClose}>
                <Modal.Header closeButton>
                    
                </Modal.Header>
                <Modal.Body>
                    <>
                        {loading ? (
                                    <Spinner className="mx-auto d-block">
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner>
                        ) :
                            (
                            
                                    <div id="SportsBettingReasons_tables" className="d-flex justify-content-center">

                                        <div className="m-3 p-3 shadow-lg border">

                                            <div className="m-2 border bg-light">

                                                <div className="m-2 d-flex justify-content-center ">
                                                <a onClick={() => handleTeam(homeid)} href="#" className={`teamreasons text-decoration-none m-2 link-dark ${activeTeamId == homeid ? 'team-reasons-active' : ''}`} data-teamid={homeid}>
                                                        <picture>
                                                        <source srcSet={`/_ie/_${sportcode}_teams_xs/${homeid}.webp`} type="image/webp" />
                                                        <img src={`/_ie/_${sportcode}_teams_xs/${homeid}.png`} style={{ height: '30px' }} />
                                                        </picture>
                                                        {homename}
                                                    </a>
                                                    <span className="mx-5"></span>
                                                <a onClick={() => handleTeam(awayid)} href="#" className={`teamreasons text-decoration-none m-2 link-dark ${activeTeamId == awayid ? 'team-reasons-active' : ''}`} data-teamid={awayid}>
                                                        <picture>
                                                        <source srcSet={`/_ie/_${sportcode}_teams_xs/${awayid}.webp`} type="image/webp" />
                                                        <img src={`/_ie/_${sportcode}_teams_xs/${awayid}.png`} style={{ height: '30px' }} />
                                                        </picture>
                                                        {awayname}
                                                    </a>
                                                </div>

                                                <div className="m-3">
                                                    <div className="m-2 d-flex align-items-center justify-content-center">

                                                        <span className="mx-2">Position:</span>

                                                    <a onClick={() => handlePosition('OFF')} role="button" href="#" data-position="OFF" className={getPositionClass('OFF', teamCounts.OFF)} disabled={teamCounts.OFF == 0} aria-disabled={teamCounts.OFF == 0}>Offense <span className="badge rounded-pill badge_reason">{teamCounts.OFF}</span></a>

                                                    <a onClick={() => handlePosition('DEF')} role="button" href="#" data-position="DEF" className={getPositionClass('DEF', teamCounts.DEF)} disabled={teamCounts.DEF == 0} aria-disabled={teamCounts.DEF == 0}>Defense <span className="badge rounded-pill badge_reason">{teamCounts.DEF}</span></a>

                                                    <a onClick={() => handlePosition('OTH')} role="button" href="#" data-position="OTH" className={getPositionClass('OTH', teamCounts.OTH)} disabled={teamCounts.OTH == 0} aria-disabled={teamCounts.OTH == 0}>Other <span className="badge rounded-pill badge_reason">{teamCounts.OTH}</span></a>

                                                    <a onClick={() => handlePosition('ALL')} role="button" href="#" data-position="ALL" className={getPositionClass('ALL', teamCounts.ALL)} disabled={teamCounts.ALL == 0} aria-disabled={teamCounts.ALL == 0}>ALL <span className="badge rounded-pill badge_reason">{teamCounts.ALL}</span></a>
                                                    </div>
                                                </div>

                                            </div>

                                            <div>
                                                <div className="d-flex justify-content-center">
                                                <h5 className="m-3 text-uppercase hdr">reasons to like the {activeTeamId == homeid ? homename : awayname}</h5>
                                                </div>
                                            <div id="div-data" data-teamid={activeTeamId} className="d-flex justify-content-center">
                                                    <ol className="list-group list-group-flush d-flex justify-content-center w-100">

                                                    {activeReasons?.map((i, index) => (
                                                        
                                                          <li key={index}  className="list-group-item  d-flex align-items-center">
                                                            <span className="m-2 float-start rnd_numb get_access">{i.num}. </span>
                                                            <ul className="list-group list-group-flush">
                                                                <li className="list-group-item border-0 pt-0" data-gameid={gameid} data-id={i.reason.Id} >
                                                                    {parse(i.s_reason.reasonA)}
                                                                </li>
                                                                <li className="list-group-item border-0 pt-0" data-gameid={gameid} data-id={i.reason.Id}>
                                                                    {parse(i.s_reason.reasonB)} 
                                                                </li>
                                                            </ul>
                                                        </li>

                                                    ))}


                                                    </ol>
                                                </div>
                                            </div>

                                            <div className="d-flex justify-content-center mt-4">
                                            <button id="prev3" onClick={handlePrevious} className="btn get_access mx-3" disabled={pageIndex == 1} >&lt;&lt; Previous</button>
                                            <button id="moreReasons" onClick={handleNext} disabled={pageIndex * pageSize >= filterTeamReasons2?.().length } className="btn get_access mx-3" >Next &gt;&gt;</button>
                                            <button id="showAll" onClick={handleShowAll} className="btn get_access mx-3" disabled={filterTeamReasons2?.().length == 0}>Show All</button>
                                            </div>
                                        </div>
                                    </div>

                            )
                        }
                    </> 
                </Modal.Body>
                
            </Modal>

            </>
        )
}

export default Reasons;